<template>
  <div class="wrap" style="height: 100%;" v-loading="loading">
    <div class="legend">
      <div class="legend-item">
        <div class="circle" style="background-color: #55ADFF"></div>
        <span>待调度</span>
      </div>
      <div class="legend-item">
        <div class="circle" style="background-color: #57D2A8"></div>
        <span>待配送</span>
      </div>
      <div class="legend-item">
        <div class="circle" style="background-color: #FF7273"></div>
        <span>已完成</span>
      </div>
      <div class="legend-item">
        <div class="circle" style="background-color: #F5D000"></div>
        <span>作废</span>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="pie el-container">
      <div class="el-aside">
        <p class="title">7天内订单</p>
        <div class="pie-inner">
          <div class="pie_inner-item">
            <div class="legend-item">
              <div class="circle" style="background-color: #55ADFF"></div>
              <span>待调度</span>
            </div>
            <div class="pie_inner-describe">
              <div class="cell">{{chartLeftOption.dataset.source[0].value}}笔</div>
              <div class="cell">{{chartLeftOption.dataset.source[0].percentage}}%</div>
              <div class="cell">{{chartLeftOption.dataset.source[0].customerNum}}家客户</div>
            </div>
            <div class="legend-item">
              <div class="circle" style="background-color: #57D2A8"></div>
              <span>待配送</span>
            </div>
            <div class="pie_inner-describe">
              <div class="cell">{{chartLeftOption.dataset.source[1].value}}笔</div>
              <div class="cell">{{chartLeftOption.dataset.source[1].percentage}}%</div>
              <div class="cell">{{chartLeftOption.dataset.source[1].customerNum}}家客户</div>
            </div>
            <div class="legend-item">
              <div class="circle" style="background-color: #FF7273"></div>
              <span>已完成</span>
            </div>
            <div class="pie_inner-describe">
              <div class="cell">{{chartLeftOption.dataset.source[2].value}}笔</div>
              <div class="cell">{{chartLeftOption.dataset.source[2].percentage}}%</div>
              <div class="cell">{{chartLeftOption.dataset.source[2].customerNum}}家客户</div>
            </div>
            <div class="legend-item">
              <div class="circle" style="background-color: #F5D000"></div>
              <span>作废</span>
            </div>
            <div class="pie_inner-describe">
              <div class="cell">{{chartLeftOption.dataset.source[3].value}}笔</div>
              <div class="cell">{{chartLeftOption.dataset.source[3].percentage}}%</div>
              <div class="cell">{{chartLeftOption.dataset.source[3].customerNum}}家客户</div>
            </div>
          </div>
          <div class="pie-chart" ref="chartLeft"></div>
        </div>
      </div>
      <div class="el-main">
        <p class="title">30天内订单</p>
        <div class="pie-inner">
          <div class="pie_inner-item">
            <div class="legend-item">
              <div class="circle" style="background-color: #55ADFF"></div>
              <span>待调度</span>
            </div>
            <div class="pie_inner-describe">
              <div class="cell">{{chartRightOption.dataset.source[0].value}}笔</div>
              <div class="cell">{{chartRightOption.dataset.source[0].percentage}}%</div>
              <div class="cell">{{chartRightOption.dataset.source[0].customerNum}}家客户</div>
            </div>
            <div class="legend-item">
              <div class="circle" style="background-color: #57D2A8"></div>
              <span>待配送</span>
            </div>
            <div class="pie_inner-describe">
              <div class="cell">{{chartRightOption.dataset.source[1].value}}笔</div>
              <div class="cell">{{chartRightOption.dataset.source[1].percentage}}%</div>
              <div class="cell">{{chartRightOption.dataset.source[1].customerNum}}家客户</div>
            </div>
            <div class="legend-item">
              <div class="circle" style="background-color: #FF7273"></div>
              <span>已完成</span>
            </div>
            <div class="pie_inner-describe">
              <div class="cell">{{chartRightOption.dataset.source[2].value}}笔</div>
              <div class="cell">{{chartRightOption.dataset.source[2].percentage}}%</div>
              <div class="cell">{{chartRightOption.dataset.source[2].customerNum}}家客户</div>
            </div>
            <div class="legend-item">
              <div class="circle" style="background-color: #F5D000"></div>
              <span>作废</span>
            </div>
            <div class="pie_inner-describe">
              <div class="cell">{{chartRightOption.dataset.source[3].value}}笔</div>
              <div class="cell">{{chartRightOption.dataset.source[3].percentage}}%</div>
              <div class="cell">{{chartRightOption.dataset.source[3].customerNum}}家客户</div>
            </div>
          </div>
          <div class="pie-chart" ref="chartRight"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      chartLeft: null,
      chartRight: null,
      chartLeftOption: {
        tooltip: {
          trigger: "item",
          formatter: ({ data }) => {
            return `${data.name} <br/> ${data.value}笔 ${data.percentage}% ${data.customerNum}家客户`
          }
        },
        color: ['#55ADFF', '#57D2A8', '#FF7273', '#F5D000'],
        series: [
          {
            name: "",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: true,
              formatter: `7天履约率\n71.43%`,
              position: "center",
              fontSize: "20",
              fontWeight: "bold"
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold"
              },
            },
            labelLine: {
              show: false
            }
          },
        ],
        dataset: {
          dimensions: ['value', 'name', 'percentage', 'customerNum'],
          source: [
            { value: 0, name: "待调度", percentage: '0', customerNum: 0 },
            { value: 0, name: "待配送", percentage: '0', customerNum: 0 },
            { value: 0, name: "已完成", percentage: '0', customerNum: 0 },
            { value: 0, name: "作废", percentage: '0', customerNum: 0 }
          ]
        }
      },
      chartRightOption: {
        tooltip: {
          trigger: "item",
          formatter: ({ data }) => {
            return `${data.name} <br/> ${data.value}笔 ${data.percentage}% ${data.customerNum}家客户`
          }
        },
        color: ['#55ADFF', '#57D2A8', '#FF7273', '#F5D000'],
        series: [
          {
            name: "",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: true,
              formatter: `7天履约率\n71.43%`,
              position: "center",
              fontSize: "20",
              fontWeight: "bold"
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold"
              },
            },
            labelLine: {
              show: false
            }
          },
        ],
        dataset: {
          dimensions: ['value', 'name', 'percentage', 'customerNum'],
          source: [
            { value: 0, name: "待调度", percentage: '0', customerNum: 0 },
            { value: 0, name: "待配送", percentage: '0', customerNum: 0 },
            { value: 0, name: "已完成", percentage: '0', customerNum: 0 },
            { value: 0, name: "作废", percentage: '0', customerNum: 0 }
          ]
        }
      }
    };
  },
  created() {
    this.getData()
  },
  beforeDestroy() {
    this.chartLeft.dispose();
    this.chartRight.dispose();
  },
  methods: {
    async getData() {
      this.loading = true
      const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/business/selectOrderAccount.html')
      this.loading = false
      if (res.code == 0) {
        this.chartLeftOption.series[0].label.formatter = `7天履约率\n${res.data.weekPercentage}`
        this.chartLeftOption.dataset.source = res.data.order7DayList.map(i => {
          let item = {}
          item['value'] = i.billNum
          item['name'] = i.billStatusStr
          item['percentage'] = i.statusPercentage
          item['customerNum'] = i.customerNum
          return item
        })
        this.chartRightOption.series[0].label.formatter = `30天履约率\n${res.data.monthPercentage}`
        this.chartRightOption.dataset.source = res.data.order30DayList.map(i => {
          let item = {}
          item['value'] = i.billNum
          item['name'] = i.billStatusStr
          item['percentage'] = i.statusPercentage
          item['customerNum'] = i.customerNum
          return item
        })
        this.$nextTick(() => {
          this.createdChart()
        })
      }
    },
    createdChart() {
      this.chartLeft = this.$echarts.init(this.$refs.chartLeft)
      this.chartLeft.setOption(this.chartLeftOption)
      this.chartRight = this.$echarts.init(this.$refs.chartRight)
      this.chartRight.setOption(this.chartRightOption)
      window.addEventListener("resize", () => {
        this.chartLeft.resize()
        this.chartRight.resize()
      })
    }
  }
};
</script>

<style lang="less" scoped>
.wrap {
  display: flex;
  flex-flow: column;
  .legend-item {
    display: flex;
    align-items: center;
    .circle {
      margin-right: 6px;
    }
  }
  .legend {
    display: flex;
    flex-shrink: 0;
    .legend-item {
      font-size: 16px;
      & + .legend-item {
        margin-left: 20px;
      }
      .circle {
        width: 12px;
        height: 12px;
      }
    }
  }
  .el-divider {
    margin: 10px 0;
  }
  .pie {
    flex: 1;
    flex-flow: wrap;
    .el-aside {
      flex: 1;
      flex-basis: auto;
      max-width: 800px;
    }
    .el-main {
      flex: 1;
      padding: 0;
      flex-basis: auto;
      max-width: 800px;
    }
    .title {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 12px;
    }
    .pie-inner {
      display: flex;
      height: calc(100% - 48px);
      justify-content: space-between;
      flex-flow: wrap;
      overflow: hidden;
      .pie_inner-item {
        flex: 1;
        min-width: 240px;
        .legend-item {
          & + .pie_inner-describe {
            margin: 8px 0;
          }
          font-size: 16px;
          .circle {
            width: 8px;
            height: 8px;
          }
        }
        .pie_inner-describe {
          font-size: 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #909399;
        }
      }
      .pie-chart {
        flex: 3;
        height: 100%;
        min-width: 300px;
        min-height: 300px;
        overflow: hidden;
      }
    }
  }
}
</style>